import React from "react";

function Mac() {
  return (
    <div>
      <h1 className="center">Mac page</h1>
    </div>
  );
}

export default Mac;
